import Repository from "./Repository";

const resource = "/applicators";

const fetchApplicators = () => {
  return Repository.get(resource, { params: { only: "active" } }).then(
    (res) => res.data
  );
};

export { fetchApplicators };

export default {
  get() {
    return Repository.get(`${resource}`);
  },

  getUser(usersId) {
    return Repository.get(`${resource}/${usersId}`);
  },

  getConnectedUser() {
    return Repository.get("/me");
  },
};
